CreditDetailLists<script>
import config from "../../config";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import pagination from "laravel-vue-pagination";
import { customerService } from "../../services";
import {
  required,
  numeric,
  maxLength,
  minValue,
} from "vuelidate/lib/validators";
import { error_message, success_message, debounce,validate_decimal_input } from "../../Helper/helper";
import CreditDetailLists from "./credit_tabs/credit-details-lists";

export default {
  components: { pagination, Layout, PageHeader, CreditDetailLists },
  data() {
    const { status, type, orderBy, sortBy } = this.$route.query;
    return {
      btnDisabled: false,
      tab: "general",
      config: config,
      addModal: false,
      customers: [],
      sortBy: sortBy || "created_at",
      sortDesc: orderBy && orderBy != "" ? orderBy : true,
      history: [],
      customerData: [],
      customerCount: "",
      paginations: {},
      limit: 2,
      search: "",
      status: status == undefined ? "0" : status,
      type: type || "1",
      loading: true,
      isDownloading: false,
      typeform: {
        amount: "",
      },
      paybackAdditionColumns: [
        {
          key: "paybackrequest",
          label: this.trans.get("__JSON__.Payback Request"),
          sortable: false,
        },

        {
          key: "payment_details",
          label: this.trans.get("__JSON__.Bank Details"),
          sortable: false,
        },


        {
          key: "date",
          label: this.trans.get("__JSON__.Date"),
          sortable: false,
        },
        {
          key: "action",
          label: this.trans.get("__JSON__.Action"),
          sortable: false,
        },
      ],

      abandonedExtraColumns: [
        {
          key: "date",
          label: this.trans.get("__JSON__.Date"),
          sortable: false,
        },
      ],

      paymentSentExtraColumns: [
        {
          key: "date",
          label: this.trans.get("__JSON__.Date"),
          sortable: false,
        },
      ],

      cancelledExtraColumns: [
        {
          key: "date",
          label: this.trans.get("__JSON__.Date"),
          sortable: false,
        },
      ],

      searchData: debounce(() => {
        const { status, type, orderBy, sortBy } = this.$data;
        this.$router.replace({
          name: "customer-credit-list",
          query: { status, type, orderBy, sortBy },
        });
        this.getCreditHistory();
      }, 500),
    };
  },
  validations: {
    typeform: {
      amount: {
        required,
        maxLength: maxLength(5),
        minValue: minValue(1),
      },
    },
  },
  mounted() {
    this.getCustomerProfile();
    this.getCreditHistory();
  },
  methods: {
    onRowClicked(item) {
      //this.$router.push({name: 'customer-detail',params: { user_id: this.base64(item.user_id)}})
    },
    validateCreditAmout(value) {
      this.typeform.amount = validate_decimal_input(value);
    },
    getCustomerProfile() {
      customerService
        .getCustomerProfile({
          user_id: this.$route.params.user_id,
        })
        .then((response) => {
          this.customers = response.data.result;
          //this.user_id = this.$route.params.user_id;
        });
    },

    onTabChanged(tabIndex) {
      var tab = [
        "general",
        "paybackRequest",
        "paymentSent",
        "cancelled",
        "abandoned",
      ];
      this.tab = tab[tabIndex];
      this.getCreditHistory();
    },

    async getCreditHistory(page) {
      this.loading = true;
      var filters = {
        search: this.search,
        status: this.status,
        type: this.type,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        customer_id: this.$route.params.user_id,
        tab: this.tab,
      };
      var url = config.api_url + "get-credit-history";
      var response = await window.axios.post(url, filters);
      this.loading = false;
      this.paginations = response.data.result.data;
      this.history = response.data.result.data.data;
      this.getCount();
      // this.customerCount = response.data.result.count;
    },

    async getCount() {
      var url = config.api_url + "get-customer-count";
      var response = await window.axios.post(url, {
        user_id: this.$route.params.user_id,
      });
      if (response.data.code === 200) {
        this.customerCount = response.data.result;
      } else {
        this.customerCount = "";
      }
    },
    sortingChanged(sortBy, sortDesc) {
      this.sortBy = sortBy;
      this.sortDesc = sortDesc;
      this.getCreditHistory();
    },

    async addCredit() {
      this.btnDisabled = true;
      this.$v.typeform.$touch();
      if (this.$v.typeform.$invalid) {
        this.btnDisabled = false;
        return;
      } else {
        var url = config.api_url + "add-customer-credit";
        var formdata = {
          ...this.typeform,
          customer_id: this.$route.params.user_id,
        };
        var response = await window.axios.post(url, formdata);
        this.btnDisabled = false;
        if (response.data.code === 200) {
          success_message(response.data.message);
          this.typeform.amount = "";
          this.addModal = false;
          this.getCreditHistory();
        } else {
          error_message(response.data.message);
        }
      }
    },
    async deleteById(id) {
      if (confirm("Are you sure you want to delete?")) {
        var url = config.api_url + "delete-customer-credit";
        var response = await window.axios.post(url, { id: id });
        if (response.data.code === 200) {
          success_message(response.data.message);
          this.getCreditHistory();
        } else {
          error_message(response.data.message);
        }
      }
    },

    async approveWithdrawal(id) {
      var url = config.api_url + "approve-customer-credit";
      var response = await window.axios.post(url, { id: id });
      if (response.data.code === 200) {
        success_message(response.data.message);
      } else {
        error_message(response.data.message);
      }
      this.getCreditHistory();
    },

    async cancelWithdrawal(id) {
      var url = config.api_url + "cancel-customer-credit";
      var response = await window.axios.post(url, { id: id });
      if (response.data.code === 200) {
        success_message(response.data.message);
        this.getCreditHistory();
      }
    },

    async pendingWithdrawal(id) {
      var url = config.api_url + "pending-customer-credit";
      var response = await window.axios.post(url, { id: id });
      if (response.data.code === 200) {
        success_message(response.data.message);
        this.getCreditHistory();
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div>
      <div class="row">
        <div class="col-12">
          <div
            class="
              page-title-box
              d-flex
              align-items-center
              justify-content-between
              icon-main-page
            "
          >
            <div class="page-title-left">
              <div class="avatar-xs mr-3">
                <span
                  class="
                    avatar-title
                    rounded-circle
                    bg-soft-primary
                    text-primary
                    font-size-18
                  "
                >
                  <i class="bx bx-user-circle"></i>
                </span>
              </div>
              <div class="report-tag">
                <h4 class="mb-0 font-size-18">
                  Customer Credit and Debit History
                </h4>
                <p>
                  <router-link :to="{ name: 'customer-credit-list' }"
                    >Credit</router-link
                  >
                  > {{ customers.user_name }} {{ customers.last_name }}
                </p>
              </div>
            </div>
            <div class="page-title-right d-flex" v-if="tab == 'general'">
              <button
                type="button"
                class="btn btn-success btn-rounded mr-2"
                @click="addModal = true"
              >
                <i class="mdi mdi-plus mr-1"></i>
                {{ trans.get("__JSON__.add_credit") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row list-table-main">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-2 offset-sm-6">
                  <div class="form-group">
                    <!-- <div class="date-range-list">
                    <label>{{ trans.get('__JSON__.Customer Type') }} :</label>
                    <select class="custom-select" v-model="type" @change="searchData()">
                      <option value="">{{ trans.get('__JSON__.All') }}</option>
                      <option value="1" selected>{{ trans.get('__JSON__.Private') }}</option>
                      <option value="5">{{ trans.get('__JSON__.Business') }}</option>
                    </select>
                  </div> -->
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <div class="date-range-list">
                      <!-- <label>{{ trans.get('__JSON__.Status') }} :</label> -->
                      <!-- <select class="custom-select" v-model="status" @change="searchData()">
                      <option value="">{{ trans.get('__JSON__.All') }}</option>
                      <option value="0" selected>{{ trans.get('__JSON__.Active') }}</option>
                      <option value="1">{{ trans.get('__JSON__.Inactive') }}</option>
                      <option value="3">{{ trans.get('__JSON__.Block') }}</option>
                    </select> -->
                    </div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <!-- <div class="date-range-list">
                  <label>{{ trans.get('__JSON__.Search') }} :</label>
                  <div class="text-sm-right">
                    <div class="search-box mr-2 d-inline-block">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="trans.get('__JSON__.Search Placeholder')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div> -->
                </div>
              </div>
              <b-tabs
                justified
                nav-class="nav-tabs-custom mt-0 order-tabs"
                content-class="p-3 text-muted"
                lazy
                @activate-tab="onTabChanged"
              >
                <b-tab @sorting="sortingChanged">
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-plus"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{
                      trans.get("__JSON__.General")
                    }}</span>
                  </template>
                  <CreditDetailLists
                    :history="history"
                    :loading="loading"
                    @sorting="sortingChanged"
                    @deleteById="deleteById"
                    :activate-tab="tab"
                  />
                </b-tab>

                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-plus"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{
                      trans.get("__JSON__.Payback Request")
                    }}</span>

                    <span
                      v-if="customerCount"
                      class="badge badge-success font-size-12"
                    >
                      {{ customerCount }}
                    </span>
                  </template>
                  <CreditDetailLists
                    :history="history"
                    :loading="loading"
                    @sorting="sortingChanged"
                    @deleteById="deleteById"
                    :extra-columns="paybackAdditionColumns"
                    :activate-tab="tab"
                    @approveWithdrawal="approveWithdrawal"
                    @cancelWithdrawal="cancelWithdrawal"
                    @pendingWithdrawal="pendingWithdrawal"
                  />
                </b-tab>

                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-plus"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{
                      trans.get("__JSON__.Payment Sent")
                    }}</span>
                  </template>
                  <CreditDetailLists
                    :history="history"
                    :loading="loading"
                    @sorting="sortingChanged"
                    @deleteById="deleteById"
                    :activate-tab="tab"
                    :extra-columns="paymentSentExtraColumns"
                  />
                </b-tab>

                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-plus"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{
                      trans.get("__JSON__.Cancelled")
                    }}</span>
                  </template>
                  <CreditDetailLists
                    :history="history"
                    :loading="loading"
                    @sorting="sortingChanged"
                    @deleteById="deleteById"
                    :activate-tab="tab"
                    :extra-columns="cancelledExtraColumns"
                  />
                </b-tab>

                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-plus"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">{{
                      trans.get("__JSON__.Abandoned")
                    }}</span>
                  </template>
                  <CreditDetailLists
                    :history="history"
                    :loading="loading"
                    @sorting="sortingChanged"
                    @deleteById="deleteById"
                    :activate-tab="tab"
                    :extra-columns="abandonedExtraColumns"
                  />
                </b-tab>
              </b-tabs>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div
                    class="
                      dataTables_paginate
                      paging_simple_numbers
                      float-right
                    "
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <pagination
                        :data="paginations"
                        :limit="limit"
                        @pagination-change-page="getCreditHistory"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add State Modal Start -->
    <b-modal
      id="modal-scoped"
      v-model="addModal"
      :title="trans.get('__JSON__.add_credit')"
      centered
      v-if="tab == 'general'"
    >
      <b-form @submit.prevent="addCredit">
        <div class="row">
          <div class="col-md-12">
            <b-form-group id="input-group-1">
              <label class="control-label required" for="amount">Amount</label>

              <b-form-input
                id="amount"
                name="amount"
                v-model="$v.typeform.amount.$model"
                type="text"
                placeholder="Please Enter Credit Amount"
                :class="{ 'is-invalid': $v.typeform.amount.$error }"
                @input="validateCreditAmout(typeform.amount)"
              ></b-form-input>
              <div v-if="$v.typeform.amount.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.amount.required"
                  >Credit amount is required</span
                >
                <span v-else-if="!$v.typeform.amount.numeric"
                  >Please Enter Valid Amount</span
                >
                <span v-else-if="!$v.typeform.amount.maxLength"
                  >Only allowed maximum 5 digits</span
                >
                <span v-else-if="!$v.typeform.amount.minValue">
                  Minimum 1 credit amount is requred
                </span>
              </div>
            </b-form-group>
          </div>
        </div>
      </b-form>
      <template slot="modal-footer">
        <div class="w-100">
          <b-button
            variant="primary"
            :disabled="btnDisabled"
            class="float-right"
            @click="addCredit"
            >{{ trans.get("__JSON__.Submit") }}</b-button
          >
          <b-button class="float-left" @click="addModal = false">{{
            trans.get("__JSON__.Close")
          }}</b-button>
        </div>
      </template>
    </b-modal>
    <!-- Add State Modal End -->
  </Layout>
</template>